import '../css/popup.scss';

const WPVQV_Popup = {
    // Function to create a popup
    createPopup: function(content, options) {
        const defaultOptions = {
            width: '400px',
            height: '300px',
            title: '',
            onClose: function() {},
            onOpen: function() {},
            galleryMode: false,
            galleryItems: [],
            currentIndex: 0,
            overlay: true,
            closeOnEscape: true,
            closeOnClickOutside: true
        };

        options = Object.assign({}, defaultOptions, options);

        // Create overlay if enabled
        let overlay = null;
        if (options.overlay) {
            overlay = document.createElement('div');
            overlay.classList.add('wpvqv-overlay');
            document.body.appendChild(overlay);
        }

        const popupContainer = document.createElement('div');
        popupContainer.classList.add('wpvqv-popup-container');
        popupContainer.style.width = options.width;
        popupContainer.style.height = options.height;

        const closeButton = document.createElement('button');
        closeButton.classList.add('wpvqv-popup-close-btn');
        closeButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" data-v-ea893728=""><path fill="currentColor" d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"></path></svg>';
        closeButton.addEventListener('click', function() {
            WPVQV_Popup.closePopup(popupContainer, overlay, options.onClose);
        });

        const popupContent = document.createElement('div');
        popupContent.classList.add('wpvqv-popup-content');
        popupContent.innerHTML = content;

        popupContent.appendChild(closeButton);

        if(options.title){
            const popupTitle = document.createElement('div');
            popupTitle.classList.add('wpvqv-popup-title');
            popupTitle.textContent = options.title;
        }
        

        

        // Close popup on Escape key if enabled
        if (options.closeOnEscape) {
            document.addEventListener('keydown', function(event) {
                if (event.key === 'Escape') {
                    WPVQV_Popup.closePopup(popupContainer, overlay, options.onClose);
                }
            });
        }

        if(options.title){
            popupContainer.appendChild(popupTitle);
        }
        //popupContainer.appendChild(closeButton);
        popupContainer.appendChild(popupContent);

        if (options.galleryMode) {
            const galleryButtons = document.createElement('div');
            galleryButtons.classList.add('wpvqv-gallery-buttons');
            galleryButtons.appendChild(prevButton);
            galleryButtons.appendChild(nextButton);
            popupContainer.appendChild(galleryButtons);
        }

        document.body.appendChild(popupContainer);

        options.onOpen();

        // Close popup on click outside if enabled
        if (options.closeOnClickOutside) {
            overlay.addEventListener('click', function() {
                WPVQV_Popup.closePopup(popupContainer, overlay, options.onClose);
            });
            popupContainer.addEventListener('click', function(event) {
                event.stopPropagation();
            });
        }

        // Disable scrolling on the page behind the popup
        document.body.style.overflow = 'hidden';
    },

    // Function to close a popup
    closePopup: function(popupContainer, overlay, onClose) {
        
        if (popupContainer && overlay) {
            popupContainer.parentNode.removeChild(popupContainer);
            overlay.parentNode.removeChild(overlay);
            document.body.style.overflow = '';
            onClose();
        }
    }
};

export default WPVQV_Popup;